import React from 'react';

import { ITEMS } from './consts';

import {
  WhoBackground,
  WhoContainer,
  Title,
  Description,
  ItemsContainer,
  Item,
  ImageContainer
} from './styled';

const Who = () => {
  return (
    <WhoBackground>
      <WhoContainer>
        <Title>We are looking for someone who:</Title>
        <Description>
          At SafetyWing, we don’t base our hiring decisions strictly on our resume— we
          look for potential just as much as your experience. Before we invite you to meet
          the team, we look closely into all components of your application for
          indications that you are someone who:
        </Description>
        <ItemsContainer>
          {ITEMS.map((item) => (
            <Item key={item?.id}>
              <ImageContainer>
                <img alt="illustration" src={item?.illustration} />
              </ImageContainer>
              <h2>{item?.description}</h2>
            </Item>
          ))}
        </ItemsContainer>
      </WhoContainer>
    </WhoBackground>
  );
};

export default Who;
